export default {"src":"/_next/static/media/googlePlay.0dab554f.svg","height":80,"width":250,"blurWidth":0,"blurHeight":0};